import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { LottieComponent } from '../../modules/dash/shared/components/lottie/lottie.component';

@Injectable({
  providedIn: 'root',
})
export class ToastresService {
  constructor(
    private toastrService: ToastrService,
    private ngbModal: NgbModal,
  ) {}

  ShowError(msg: string) {
    const modalRef = this.ngbModal.open(LottieComponent, {
      centered: true,
      windowClass: 'modal-rounded-circle',
    });
    modalRef.componentInstance.size = '450px';
    modalRef.componentInstance.path = 'assets/json/animation-failed.json';
    modalRef.componentInstance.msg = msg;
  }

  ShowSuccess(msg: string) {
    const modalRef = this.ngbModal.open(LottieComponent, {
      centered: true,
      windowClass: 'modal-rounded-circle',
    });
    modalRef.componentInstance.size = '450px';
    modalRef.componentInstance.path = 'assets/json/animation-success.json';
  }

  ShowInfo(msg: string, title: string) {
    this.toastrService.info(msg, title, {
      positionClass: 'toast-top-left',
      timeOut: 7000,
      extendedTimeOut: 3000,
    });
  }

  ShowWarning(msg: string) {
    this.toastrService.warning(msg, '', {
      positionClass: 'toast-top-left',
      timeOut: 5000,
      extendedTimeOut: 3000,
    });
  }
}
